export default {
  'approvalFiltersUserExtraFields.form.row': 'Filtro de campo extra de usuario',
  'approvalFiltersUserExtraFields.form.addRow': 'Agregar filtro de campo extra de usuario',
  'approvalFiltersUserExtraFields.form.noRows':
    'Aún no hay filtros de campo extra de usuario. Agrega al menos uno.',
};
